type IconProps = {
  className?: string;
};

export const AllSeaCarriersIcon = ({ className }: IconProps) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
    <rect width="20" height="20" fill="url(#paint0_linear_3854_2634)" rx="3.333"></rect>
    <g clipPath="url(#clip0_3854_2634)">
      <path
        fill="#fff"
        d="M7.26 12.372c.238.233.703.426 1.036.43.376 0 .821-.104 1.048-.389a.84.84 0 0 1 .656-.316.85.85 0 0 1 .656.315c.227.284.672.388 1.048.388.333-.004.798-.196 1.036-.43l1.63-1.574a.65.65 0 0 0 .167-.4.6.6 0 0 0-.394-.541l-.74-.237V7.13a.57.57 0 0 0-.568-.568h-1.118l-.016-.71a.425.425 0 0 0-.425-.425H8.724a.426.426 0 0 0-.426.425l-.016.71H7.164a.57.57 0 0 0-.567.568v2.486l-.74.238a.6.6 0 0 0-.394.54c0 .13.074.31.166.402zm.471-4.674h4.537v1.553l-2.095-.674A.6.6 0 0 0 10 8.554a.5.5 0 0 0-.174.023l-2.095.675zm6.909 5.684c-.86-.15-.807-.498-1.234-.498-.443 0-.553.537-1.705.537-.86 0-1.288-.372-1.3-.382a.57.57 0 0 0-.397-.155c-.439 0-.56.537-1.705.537-.862 0-1.289-.372-1.301-.381a.595.595 0 0 0-.795-.006c-.514.443-1.307.211-1.307.879 0 .271.226.541.562.541.173 0 .702-.124 1.139-.368.345.194.913.416 1.703.416s1.354-.221 1.7-.416c.346.195.914.416 1.703.416.79 0 1.355-.222 1.701-.416.438.245.97.368 1.139.368a.55.55 0 0 0 .561-.542.55.55 0 0 0-.464-.53"
      ></path>
    </g>
    <defs>
      <linearGradient id="paint0_linear_3854_2634" x1="0" x2="23.627" y1="20" y2="6.217" gradientUnits="userSpaceOnUse">
        <stop stopColor="#50ADFF"></stop>
        <stop offset="1" stopColor="#006FF1"></stop>
      </linearGradient>
      <clipPath id="clip0_3854_2634">
        <path fill="#fff" d="M4.167 4.13h11.667v11.668H4.167z"></path>
      </clipPath>
    </defs>
  </svg>
);

export const KeyIcon = ({ className }: IconProps) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
    <path
      d="M12.5 2.5a5 5 0 0 0-4.79 6.44L2.5 14.15V17.5h3.35l1.03-1.03v-1.6h1.6l1.1-1.1v-1.6h1.6l.73-.73A5 5 0 1 0 12.5 2.5Zm1.56 4.69a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Z"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinejoin="round"
    />
  </svg>
);

export const PlusIcon = ({ className }: IconProps) => (
  <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path d="M8 3.5v9M3.5 8h9" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

export const CopyIcon = ({ className }: IconProps) => (
  <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <rect x="5.75" y="5.75" width="8.5" height="8.5" rx="2" stroke="currentColor" strokeWidth="1.4" />
    <path
      d="M10.25 5.75v-2a2 2 0 0 0-2-2h-4.5a2 2 0 0 0-2 2v4.5a2 2 0 0 0 2 2h2"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
  </svg>
);

export const CheckIcon = ({ className }: IconProps) => (
  <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path d="m3.5 8.5 3 3 6-7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const WarningIcon = ({ className }: IconProps) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
    <path d="M10 2.75 1.75 17h16.5L10 2.75Z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
    <path d="M10 8v3.75" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <circle cx="10" cy="14.25" r="0.9" fill="currentColor" />
  </svg>
);

export const CloseIcon = ({ className }: IconProps) => (
  <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path d="m4 4 8 8M12 4l-8 8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

/** Eye, as used by the password fields in the design prototype. */
export const EyeIcon = ({ className }: IconProps) => (
  <svg className={className} viewBox="0 0 490 490" fill="currentColor" aria-hidden="true">
    <path d="M486.617 255.067c4.6-6.3 4.4-14.9-.5-21-74.1-91.1-154.1-137.3-237.9-137.3-142.1 0-240.8 132.4-244.9 138-4.6 6.3-4.4 14.9.5 21 74 91.2 154 137.4 237.8 137.4 142.1 0 240.8-132.4 245-138.1zm-245 103.8c-69.8 0-137.8-38.4-202.4-114 25.3-29.9 105.7-113.8 209-113.8 69.8 0 137.8 38.4 202.4 114-25.3 29.9-105.7 113.8-209 113.8z" />
    <path d="M244.917 157.867c-48 0-87.1 39.1-87.1 87.1s39.1 87.1 87.1 87.1 87.1-39.1 87.1-87.1-39.1-87.1-87.1-87.1zm0 139.9c-29.1 0-52.8-23.7-52.8-52.8s23.7-52.8 52.8-52.8 52.8 23.7 52.8 52.8-23.7 52.8-52.8 52.8z" />
  </svg>
);

export const EyeOffIcon = ({ className }: IconProps) => (
  <svg className={className} viewBox="0 0 128 128" fill="currentColor" aria-hidden="true">
    <path d="m79.891 65.078 7.27-7.27C87.69 59.787 88 61.856 88 64c0 13.234-10.766 24-24 24-2.144 0-4.213-.31-6.192-.839l7.27-7.27a15.929 15.929 0 0 0 14.813-14.813zm47.605-3.021c-.492-.885-7.47-13.112-21.11-23.474l-5.821 5.821c9.946 7.313 16.248 15.842 18.729 19.602C114.553 71.225 95.955 96 64 96c-4.792 0-9.248-.613-13.441-1.591l-6.573 6.573C50.029 102.835 56.671 104 64 104c41.873 0 62.633-36.504 63.496-38.057a3.997 3.997 0 0 0 0-3.886zm-16.668-39.229-88 88C22.047 111.609 21.023 112 20 112s-2.047-.391-2.828-1.172a3.997 3.997 0 0 1 0-5.656l11.196-11.196C10.268 83.049 1.071 66.964.504 65.943a4 4 0 0 1 0-3.887C1.367 60.504 22.127 24 64 24c10.827 0 20.205 2.47 28.222 6.122l12.95-12.95c1.563-1.563 4.094-1.563 5.656 0s1.563 4.094 0 5.656zM34.333 88.011 44.46 77.884C41.663 73.96 40 69.175 40 64c0-13.234 10.766-24 24-24 5.175 0 9.96 1.663 13.884 4.459l8.189-8.189C79.603 33.679 72.251 32 64 32 32.045 32 13.447 56.775 8.707 63.994c3.01 4.562 11.662 16.11 25.626 24.017zm15.934-15.935 21.809-21.809C69.697 48.862 66.958 48 64 48c-8.822 0-16 7.178-16 16 0 2.958.862 5.697 2.267 8.076z" />
  </svg>
);
